var require_runtime = require('./_virtual/_rolldown/runtime.cjs');
var require_attachShareScopeMap = require('./attachShareScopeMap.cjs');
var require_constant = require('./constant.cjs');
var require_updateOptions = require('./updateOptions.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
//#region src/remotes.ts
function remotes(options) {
    require_updateOptions.updateRemoteOptions(options);
    var chunkId = options.chunkId, promises = options.promises, webpackRequire = options.webpackRequire, chunkMapping = options.chunkMapping, idToExternalAndNameMapping = options.idToExternalAndNameMapping, idToRemoteMap = options.idToRemoteMap;
    require_attachShareScopeMap.attachShareScopeMap(webpackRequire);
    if (webpackRequire.o(chunkMapping, chunkId)) chunkMapping[chunkId].forEach((id)=>{
        var getScope = webpackRequire.R;
        if (!getScope) getScope = [];
        var data = idToExternalAndNameMapping[id];
        var remoteInfos = idToRemoteMap[id] || [];
        if (getScope.indexOf(data) >= 0) return;
        getScope.push(data);
        if (data.p) return promises.push(data.p);
        var onError = (error)=>{
            if (!error) error = /* @__PURE__ */ new Error("Container missing");
            if (typeof error.message === "string") error.message += `\nwhile loading "${data[1]}" from ${data[2]}`;
            webpackRequire.m[id] = ()=>{
                throw error;
            };
            data.p = 0;
        };
        var handleFunction = (fn, arg1, arg2, d, next, first)=>{
            try {
                var promise = fn(arg1, arg2);
                if (promise && promise.then) {
                    var p = promise.then((result)=>next(result, d), onError);
                    if (first) promises.push(data.p = p);
                    else return p;
                } else return next(promise, d, first);
            } catch (error) {
                onError(error);
            }
        };
        var onExternal = (external, _, first)=>external ? handleFunction(webpackRequire.I, data[0], 0, external, onInitialized, first) : onError();
        var onInitialized = (_, external, first)=>handleFunction(external.get, data[1], getScope, 0, onFactory, first);
        var onFactory = (factory)=>{
            data.p = 1;
            webpackRequire.m[id] = (module)=>{
                module.exports = factory();
            };
        };
        var onRemoteLoaded = ()=>{
            try {
                var remoteModuleName = (0, _module_federation_sdk.decodeName)(remoteInfos[0].name, _module_federation_sdk.ENCODE_NAME_PREFIX) + data[1].slice(1);
                var instance = webpackRequire.federation.instance;
                var loadRemote = ()=>webpackRequire.federation.instance.loadRemote(remoteModuleName, {
                        loadFactory: false,
                        from: "build"
                    });
                if (instance.options.shareStrategy === "version-first") {
                    var shareScopes = Array.isArray(data[0]) ? data[0] : [
                        data[0]
                    ];
                    return Promise.all(shareScopes.map((shareScope)=>instance.sharedHandler.initializeSharing(shareScope))).then(()=>{
                        return loadRemote();
                    });
                }
                return loadRemote();
            } catch (error) {
                onError(error);
            }
        };
        if (remoteInfos.length === 1 && require_constant.FEDERATION_SUPPORTED_TYPES.includes(remoteInfos[0].externalType) && remoteInfos[0].name) handleFunction(onRemoteLoaded, data[2], 0, 0, onFactory, 1);
        else handleFunction(webpackRequire, data[2], 0, 0, onExternal, 1);
    });
}
//#endregion
exports.remotes = remotes; //# sourceMappingURL=remotes.cjs.map
